import React from 'react';

import directmessage from '../../../images/directmessage.svg';

import { FOHImage } from '../../ingredients';

export const FOHDirectMessageIcon = (props: any) => (
  <FOHImage
    source={{ uri: directmessage }}
    style={{ width: 20, height: 20 }}
    {...props}
  />
);
